<template>
  <div>
    <v-row align="center" dense justify="start" class="my-1">
      <v-col v-for="tag in shortTags" :key="tag._id" class="flex-grow-0">
        <v-chip small>
          {{ tag.tag }}
        </v-chip>
      </v-col>

      <v-col v-if="fullTagCount > maxVisible" class="flex-grow-0">
        <v-btn
          small
          depressed
          rounded
          @click.stop="$refs.tagsDialog.openDialog()"
        >
          {{
            $tc("employee.tags.andMore", fullTagCount - maxVisible, {
              count: fullTagCount - maxVisible,
            })
          }}
        </v-btn>
      </v-col>
    </v-row>

    <employee-tags-dialog ref="tagsDialog" :tags="item.tags || []" />
  </div>
</template>

<script>
import EmployeeTagsDialog from "./employeeTagsDialog.vue";

export default {
  components: {
    EmployeeTagsDialog,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      maxVisible: 1,
    };
  },
  computed: {
    fullTagCount() {
      return (this.item.tags || []).length;
    },
    shortTags() {
      return (this.item.tags || []).slice(0, this.maxVisible);
    },
  },
};
</script>
